// import external dependencies

import "jquery";
import "bootstrap";

// Import Slick
import "slick-carousel";

// Import everything from autoload
import "./autoload/_bootstrap.js";

jQuery(document).ready(() => {
  $(".slider-section_container__slider ").slick({
    prevArrow: $(".prev-slide"),
    nextArrow: $(".next-slide"),
  });

  $(".page-template-contact-us-template #field_1_4").addClass("gf_right_half");
  $(".page-template-contact-us-template #field_1_1").addClass("gf_left_half");
  $(".page-template-home-template .gform_wrapper").addClass(
    "gf_simple_horizontal_wrapper"
  );
  $(".page-template-home-template .message-field").addClass(
    "gfield_visibility_hidden"
  );

  let resize = function() {
    let $field = $(".page-template-home-template .gfield");
    let $error_field = $(".page-template-home-template .gfield_error");

    if (window.innerWidth >= 1440) {
      $field.addClass("gf_inline");
      $error_field.addClass("gf_inline");
      return;
    }

    $field.removeClass("gf_inline");
    $error_field.removeClass("gf_inline");
  };

  resize();

  $(window).resize(resize);

  // Sticky nav
  var stickyNavTop = $(".header").offset().top;

  var stickyNav = function() {
    var scrollTop = $(window).scrollTop();

    if (scrollTop > stickyNavTop) {
      $(".brand").addClass("sticky");
    } else {
      $(".brand").removeClass("sticky");
    }
  };

  stickyNav();

  $(window).scroll(function() {
    stickyNav();
  });
});
